import { render, staticRenderFns } from "./ViewDetailsBanner.vue?vue&type=template&id=0bc0cf7a&scoped=true"
import script from "./ViewDetailsBanner.vue?vue&type=script&lang=js"
export * from "./ViewDetailsBanner.vue?vue&type=script&lang=js"
import style0 from "./ViewDetailsBanner.vue?vue&type=style&index=0&id=0bc0cf7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc0cf7a",
  null
  
)

export default component.exports